module.exports = __webpack_public_path__ + "static/media/ThumbsDown_selected.50ea6a21.svg";